import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Form, Message } from 'semantic-ui-react';
import PINInput from 'components/common/PINInput';
import approveWalletTransaction, {
  resetApproveWalletTransaction,
} from 'redux/actions/wallets/approveWalletTransaction';
import getCurrentOrg from 'helpers/getCurrentOrg';
import SimpleModal from '../SimpleModal';
import './index.scss';

const ApproveWalletTransactionModal = ({
  open,
  onClose,
  requestId,
}) => {
  const dispatch = useDispatch();
  const [pin, setPin] = useState('');
  const [action, setAction] = useState('');
  const currentOrg = getCurrentOrg();

  const { loading, error } = useSelector(
    ({ wallets: { approveWalletTransaction } }) =>
      approveWalletTransaction,
  );

  const handleClose = () => {
    setPin('');
    setAction('');
    resetApproveWalletTransaction()(dispatch);
    onClose();
  };

  const handlePinChange = (_, { value }) => {
    setPin(value);
  };

  const handleAction = action => {
    if (!pin) return;

    setAction(action);

    approveWalletTransaction({
      organizationId: currentOrg?.id,
      requestId,
      action,
      data: { password: pin },
      onSuccess: () => {
        handleClose();
      },
    })(dispatch);
  };

  return (
    <SimpleModal
      title="Approve wallet transaction"
      open={open}
      onClose={handleClose}
      className="approve-wallet-transaction-modal"
    >
      <div className="approve-wallet-transaction-modal__body">
        <p className="approve-wallet-transaction-modal__warning">
          Approving this wallet transaction is permanent and cannot be
          reversed
        </p>

        <Form>
          <Form.Input label="Provide PIN to approve transaction">
            <PINInput
              fluid
              label="Provide PIN to approve transaction"
              name="password"
              onInputChange={handlePinChange}
              onChange={handlePinChange}
              error={error}
            />
          </Form.Input>
        </Form>

        {error && error.message && (
          <Message negative>{error.message}</Message>
        )}

        <div className="approve-wallet-transaction-modal__actions">
          <Button
            className="approve-wallet-transaction-modal__actions__decline"
            content="Decline"
            loading={loading && action !== 'accept'}
            disabled={loading || !pin}
            onClick={() => handleAction('reject')}
          />
          <Button
            color="blue"
            content="Approve"
            loading={loading && action === 'accept'}
            disabled={loading || !pin}
            onClick={() => handleAction('accept')}
          />
        </div>
      </div>
    </SimpleModal>
  );
};

ApproveWalletTransactionModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  requestId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
};

export default ApproveWalletTransactionModal;
